import { DictionarySupplier, ExtractSupplier, LoadingStatusEnum, ExtractSupplierSchema, DictionarySupplierSchema } from "etl/types";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { displayApiErrorToast } from "core/src/slices/ui/useCases/display-api-error-toast/display-api-error-toast.use-case";

export type LoadSupplierRequest = {
	forceReload?: boolean
} | void;

type LoadSuppliersResponse = {
	extractSuppliers: ExtractSupplier[];
	dictionarySuppliers: DictionarySupplier[];
};

export const loadSuppliers = createAppAsyncThunk<LoadSuppliersResponse, LoadSupplierRequest>(
	"etlData/loadSuppliers",
	async (_, { extra, rejectWithValue, dispatch, getState }) => {
		const { selectedEtlImportUuid } = getState().etlData;

		if (!selectedEtlImportUuid) {
			return rejectWithValue("No etl import selected");
		}

		try {
			const [extractSuppliers, dictionarySuppliers] = await Promise.all([
				extra.etlClient.findAll(ExtractSupplierSchema, { params: { etlImportUuid: selectedEtlImportUuid } }),
				extra.etlClient.findAll(DictionarySupplierSchema, { params: { etlImportUuid: selectedEtlImportUuid } }),
			]);

			return {
				extractSuppliers,
				dictionarySuppliers,
			}
		} catch (error) {
			dispatch(displayApiErrorToast(error));
			return rejectWithValue(error);
		}
	},
	{
		condition: (data, { getState }) => {
			if (data?.forceReload) return true;
			if (!getState().etlData.selectedEtlImportUuid) return false;
			return [LoadingStatusEnum.NotLoaded, LoadingStatusEnum.Error].includes(getState().etlData.suppliersLoadingStatus);
		}
	}
);
